/** [PT-8308] Claude Tauro 10x copy helpers shared by old-dashboard promotion UI. */

export type PromotionTitlePart = {type: 'text' | 'money'; value: string}

export function promotionBannerEyebrow(maxMultiplier: number): string {
  return `TAURO 10X · UP TO ${maxMultiplier}X`
}

/** Splits a CRM title so amounts like `1,000 USD` / `$50,000` render as coral `<em>`. */
export function highlightPromotionTitleParts(title: string): PromotionTitlePart[] {
  const pattern = /(\$?\d{1,3}(?:,\d{3})+(?:\.\d+)?(?:\s*USD)?|\d+(?:\.\d+)?\s*USD)/gi
  const parts: PromotionTitlePart[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  while ((match = pattern.exec(title)) != null) {
    if (match.index > lastIndex) {
      parts.push({type: 'text', value: title.slice(lastIndex, match.index)})
    }
    parts.push({type: 'money', value: match[0]})
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < title.length) parts.push({type: 'text', value: title.slice(lastIndex)})
  return parts.length > 0 ? parts : [{type: 'text', value: title}]
}

export const PROMOTION_HOW_IT_WORKS = [
  {
    title: 'Pick a tier and open the account',
    text: 'A Factorised Account on MT5 Classic with the Factor you chose. Takes a minute.',
  },
  {
    title: 'Deposit',
    text: 'Within the deposit range of your Factor. Your starting balance is the deposit x the Factor.',
  },
  {
    title: 'Trade or copy',
    text: 'Trade yourself, or copy a strategy on Tauro Connect. Your choice.',
  },
  {
    title: 'Keep going',
    text:
      'Deposit more at any time, withdraw your profits as often as you like (the account keeps trading), or close the account to get your deposits back. After a liquidation, reload the same account.',
  },
] as const

export const PROMOTION_RULES_SHORT = [
  'You can never lose more than your deposits. The Factorised Boost is Tauro\'s money.',
  'One active Factorised Account at a time, up to 3 in total.',
  'Deposit more at any time: every deposit x the Factor is added to your trading balance; your starting balance and closing level move up with it.',
  'Withdraw your profits as often as you like; the account keeps trading. Tauro\'s share is taken at the same time.',
  'Leverage is fixed per Factor. No internal transfers to or from the account.',
  'Your terms stay the same for the life of the account, even after this offer ends.',
  'After a liquidation you can reload the account with a new deposit, as often as you like.',
  'Copy trading is possible with the usual acknowledgment. It is not required.',
] as const

/** [PT-8311] Print-safe PDF kit — empty state + hero/ready CTAs. */
export const PROMOTION_EMPTY_TITLE = 'This offer is not available for your account'
export const PROMOTION_EMPTY_BODY_COUNTRY =
  'The Tauro 10x offer is not available in your country at the moment. You can still open your other account types.'
export const PROMOTION_HERO_READ_RULES_LABEL = 'Read the rules'
export const PROMOTION_READY_READ_RULES_LABEL = 'Read the full rules'
export const PROMOTION_OPEN_ACCOUNT_CTA = 'Open a Factorised Account →'
